// A short overview must represent every available origin before repeating one.
// Full lists keep their original order and identities.
export function mixedPreview<T>(items: T[], limit: number, origin: (item: T) => string): T[] {
  const groups = new Map<string, T[]>();
  for (const item of items) {
    const key = origin(item);
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key)!.push(item);
  }
  const result: T[] = [];
  while (result.length < limit && [...groups.values()].some(group => group.length)) {
    for (const group of groups.values()) {
      if (group.length && result.length < limit) result.push(group.shift()!);
    }
  }
  return result;
}
